module.exports = __webpack_public_path__ + "static/media/edit.e11bfe41.svg";